import CheckIcon from "@mui/icons-material/Check";
import {
  type GridColDef,
  type GridRenderCellParams,
} from "@mui/x-data-grid-pro";

/** 「他ユーザー取得」の表示名（列見出し・SPカードで共通） */
export const OTHER_USER_RESOURCE_LABEL = "他ユーザー取得";

/**
 * 共有ONの会社で、同僚が取得した行に印を付ける列（不動産登記の取得済み一覧と同じ表示）
 * @returns 列定義
 */
export const makeOtherUserResourceColumn = (): GridColDef => ({
  field: "isOtherUserResource",
  headerName: OTHER_USER_RESOURCE_LABEL,
  width: 130,
  sortable: false,
  align: "center",
  headerAlign: "center",
  renderCell: ({ value }: GridRenderCellParams<boolean>) =>
    value === true ? (
      <CheckIcon
        color="action"
        fontSize="small"
        aria-label={OTHER_USER_RESOURCE_LABEL}
      />
    ) : (
      ""
    ),
});
